import type { Settings as LayoutSettings } from '@ant-design/pro-layout';
import { PageLoading } from '@ant-design/pro-layout';
import { notification } from 'antd';
import { getIntl, getLocale, RequestConfig, RunTimeLayoutConfig, history } from 'umi';
import { isRenew } from './utils/utils';

export const initialStateConfig = {
  loading: <PageLoading />,
};

/**
 * @see  https://umijs.org/en-US/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  acceptTerm?: boolean | undefined;
}> {
  return {
    acceptTerm: Boolean(localStorage.getItem('acceptTerm')),
    settings: {},
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    disableContentMargin: true,
    onPageChange: () => {
      // const { location } = history;
      // if (!initialState?.currentUser && location.pathname !== loginPath) {
      //   history.push(loginPath);
      // }
    },
    hasSiderMenu: false,
    menuRender: false, //Will remove sidebar
    menuHeaderRender: undefined,
    headerContentRender: false,
    ...initialState?.settings,
  };
};

const headerInterceptor = (url: string, options: RequestConfig) => {
  const authHeader = {} as any;
  const locale = getLocale().split('-')[0];
  const jwt = localStorage.getItem('jwt');
  if (jwt) {
    authHeader.Authorization = 'Bearer ' + jwt;
  }
  if (url.includes('/clients') || url.includes('/quotes')) {
    return {
      url: `${url}`,
      options: {
        ...options,
        interceptors: true,
       headers: { ...authHeader, ...options.headers }, 
      },
    };
  }
  return {
    url: `${url}`,
    options: {
      ...options,
      params: { locale, ...options.params },
      interceptors: true,
      headers: { ...authHeader, ...options.headers }, 
    },
  };
};

export const request: RequestConfig = {
  errorHandler: (error) => {
    const intl = getIntl(getLocale());

    const { response, data, request: requestError } = error;
    if (response.status === 400 && !requestError.url.includes('/related_list')) {
      history.push('/400', {
        title: data?.error,
        message: data?.message,
        canBack: isRenew,
      });
    } else {
      notification.error({
        description:
          data.message ??
          intl.formatMessage({
            id: 'app.request.error.' + response.status,
            defaultMessage: 'Something wrong now, please try again!',
          }),
        message: intl.formatMessage({
          id: 'app.request.error-request',
        }),
      });
    }
    throw error;
  },
  requestInterceptors: [headerInterceptor],
};

export const locale = {
  getLocale() {
    const lang =
      typeof sessionStorage !== 'undefined' && sessionStorage
        ? window.sessionStorage.getItem('umi_locale')
        : 'en-US';
    return lang || 'en-US';
  },
  setLocale({ lang, updater }: any) {
    updater();
    sessionStorage.setItem('umi_locale', lang);
  },
};
